// extracted by mini-css-extract-plugin
module.exports = {"inputField":"InputField_inputField__iyWt2","text":"InputField_text__2pT2t","number":"InputField_number__Xyx7J"};